import React from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { SelectButton } from 'primereact/selectbutton';
import { Tooltip } from 'primereact/tooltip';

const VIEW_OPTIONS = [
    { label: 'Día', value: 'day' },
    { label: 'Semana', value: 'week' }
];

const AgendaHeader = ({
    idPrefix = 'ventas-agenda',
    title = 'Mi agenda',
    description = 'Planificación visual de visitas comerciales.',
    viewMode,
    dateLabel,
    selectedDate,
    newVisitDisabled,
    newVisitTooltip,
    hideNewVisitButton = false,
    onViewModeChange,
    onDateChange,
    onPrevious,
    onNext,
    onToday,
    onNewVisit,
    onNewOffice
}) => {
    return (
        <div className="surface-card border-round p-3 shadow-1 ventas-agenda-header">
            {!hideNewVisitButton && newVisitTooltip ? <Tooltip target=".ventas-new-visit-tooltip-target" /> : null}
            <div className="flex flex-column xl:flex-row xl:align-items-center xl:justify-content-between gap-3">
                <div>
                    <h3 className="m-0">{title}</h3>
                    <p className="text-color-secondary mt-1 mb-0">{description}</p>
                </div>

                <div className="ventas-agenda-tools">
                    <div className="ventas-view-switch">
                        <label id={`${idPrefix}-view-mode-label`} className="block text-900 font-medium mb-2">
                            Vista
                        </label>
                        <SelectButton
                            value={viewMode}
                            options={VIEW_OPTIONS}
                            onChange={(event) => event.value && onViewModeChange(event.value)}
                            aria-labelledby={`${idPrefix}-view-mode-label`}
                            className="w-full"
                        />
                    </div>
                    {selectedDate && onDateChange ? (
                        <div className="ventas-date-picker">
                            <label htmlFor={`${idPrefix}-date-picker`} className="block text-900 font-medium mb-2">
                                Ir a fecha
                            </label>
                            <Calendar
                                inputId={`${idPrefix}-date-picker`}
                                value={selectedDate}
                                onChange={(event) => event.value && onDateChange(event.value)}
                                dateFormat="dd/mm/yy"
                                showIcon
                                showButtonBar
                                readOnlyInput
                                className="w-full"
                            />
                        </div>
                    ) : null}
                    {!hideNewVisitButton ? (
                        <>
                            <span
                                className="ventas-new-visit-tooltip-target ventas-new-visit-wrapper"
                                data-pr-tooltip={newVisitDisabled ? newVisitTooltip : undefined}
                                data-pr-position="top"
                            >
                                <Button
                                    type="button"
                                    label="Nueva visita"
                                    icon="pi pi-plus"
                                    outlined
                                    className="ventas-new-visit-button"
                                    onClick={onNewVisit}
                                    aria-label="Crear nueva visita"
                                    disabled={newVisitDisabled}
                                />
                            </span>
                            {onNewOffice ? (
                                <span
                                    className="ventas-new-visit-tooltip-target ventas-new-visit-wrapper"
                                    data-pr-tooltip={newVisitDisabled ? newVisitTooltip : undefined}
                                    data-pr-position="top"
                                >
                                    <Button
                                        type="button"
                                        label="Tiempo de oficina"
                                        icon="pi pi-briefcase"
                                        outlined
                                        className="ventas-new-visit-button"
                                        onClick={onNewOffice}
                                        aria-label="Planificar tiempo de oficina"
                                        disabled={newVisitDisabled}
                                    />
                                </span>
                            ) : null}
                        </>
                    ) : null}
                </div>
            </div>

            <div className="ventas-date-nav mt-3">
                <Button type="button" icon="pi pi-chevron-left" className="p-button-text" onClick={onPrevious} aria-label="Ir al periodo anterior" />
                <div className="ventas-date-label" aria-live="polite">
                    {dateLabel}
                </div>
                <Button type="button" icon="pi pi-chevron-right" className="p-button-text" onClick={onNext} aria-label="Ir al periodo siguiente" />
                <Button type="button" label="Hoy" className="p-button-sm p-button-outlined ventas-today-button" onClick={onToday} aria-label="Volver a hoy" />
            </div>
        </div>
    );
};

export default AgendaHeader;
